import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import {
  $azsPoints,
  changePopupDataEv,
} from '../../../models/investProModel/index.js';
import { $activeProjects } from '../../../models/activeFiltersModel/index.js';
import { changeLayerVisibility, flyTo } from '../../../utils/mapbox-utils.js';

const onClusterClick = (e) => {
  const features = window.map.queryRenderedFeatures(e.point, {
    layers: ['invest_pro_cluster_azs_layer'],
  });
  const clusterId = features[0].properties.cluster_id;
  window.map
    .getSource(`invest_pro_azs_source`)
    .getClusterExpansionZoom(clusterId, (err, zoom) => {
      if (err) return;

      window.map.easeTo({
        center: features[0].geometry.coordinates,
        zoom,
      });
    });
};

const onDotClick = (e) => {
  const feature = e.features[0];
  const coordinates = feature.geometry.coordinates.slice();
  flyTo(coordinates, 12);
  changePopupDataEv(feature);
};

function AzsLayer() {
  const mapLoaded = useUnit($mapLoaded);
  const dots = useUnit($azsPoints);
  const activeProjects = useUnit($activeProjects);

  const createLayer = (update) => {
    const dotsData = {
      type: 'FeatureCollection',
      features: dots,
    };

    if (update) {
      window.map.getSource('invest_pro_azs_source').setData(dotsData);
    } else {
      if (!window.map.getSource('invest_pro_azs_source')) {
        window.map.addSource('invest_pro_azs_source', {
          type: 'geojson',
          data: dotsData,
          cluster: true,
          clusterMaxZoom: 14,
          clusterRadius: 50,
          generateId: true,
        });
      }

      if (!window.map.getLayer('invest_pro_dots_azs_layer')) {
        // FIXME Cluster layer
        window.map.addLayer({
          id: 'invest_pro_cluster_azs_layer',
          type: 'circle',
          source: 'invest_pro_azs_source',
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': '#B22222',
            'circle-stroke-color': 'black',
            'circle-stroke-width': 3,
            'circle-radius': 7,
          },
        });

        window.map.addLayer({
          id: `invest_pro_dots_bg_azs_layer`,
          type: 'circle',
          source: `invest_pro_azs_source`,
          filter: ['!', ['has', 'point_count']],
          paint: {
            'circle-color': 'white',
            'circle-radius': 12,
          },
        });

        // FIXME Unclustered dots layer
        window.map.addLayer({
          id: `invest_pro_dots_azs_layer`,
          type: 'symbol',
          source: `invest_pro_azs_source`,
          filter: ['!', ['has', 'point_count']],
          layout: {
            'icon-image': 'azs',
            'icon-size': 1,
            'icon-allow-overlap': true,
          },
        });

        // FIXME Labels layer
        window.map.addLayer({
          id: `invest_pro_azs_labels_layer`,
          type: 'symbol',
          source: `invest_pro_azs_source`,
          filter: ['has', 'point_count'],
          layout: {
            'text-field': ['get', 'point_count_abbreviated'],
            'text-size': 12,
          },
          paint: {
            'text-color': 'white',
          },
        });

        window.map.on('click', 'invest_pro_cluster_azs_layer', onClusterClick);
        window.map.on('click', 'invest_pro_dots_azs_layer', onDotClick);

        window.map.on('mouseenter', 'invest_pro_dots_azs_layer', () => {
          window.map.getCanvas().style.cursor = 'pointer';
        });
        window.map.on('mouseenter', 'invest_pro_cluster_azs_layer', () => {
          window.map.getCanvas().style.cursor = 'pointer';
        });

        window.map.on('mouseleave', 'invest_pro_dots_azs_layer', () => {
          window.map.getCanvas().style.cursor = '';
        });
        window.map.on('mouseleave', 'invest_pro_cluster_azs_layer', () => {
          window.map.getCanvas().style.cursor = '';
        });

        changeLayerVisibility('invest_pro_dots_bg_azs_layer', false);
        changeLayerVisibility('invest_pro_cluster_azs_layer', false);
        changeLayerVisibility('invest_pro_dots_azs_layer', false);
        changeLayerVisibility('invest_pro_azs_labels_layer', false);
      }
    }
  };

  useEffect(() => {
    if (mapLoaded && dots) {
      if (window.map.getLayer('invest_pro_dots_azs_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, dots]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('invest_pro_dots_azs_layer')) {
      if (activeProjects.includes('azs')) {
        changeLayerVisibility('invest_pro_dots_bg_azs_layer', true);
        changeLayerVisibility('invest_pro_cluster_azs_layer', true);
        changeLayerVisibility('invest_pro_dots_azs_layer', true);
        changeLayerVisibility('invest_pro_azs_labels_layer', true);
      } else {
        changeLayerVisibility('invest_pro_dots_bg_azs_layer', false);
        changeLayerVisibility('invest_pro_cluster_azs_layer', false);
        changeLayerVisibility('invest_pro_dots_azs_layer', false);
        changeLayerVisibility('invest_pro_azs_labels_layer', false);
      }
    }
  }, [activeProjects]);

  return null;
}

export default AzsLayer;
